import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class TieTypes extends Component {
  render() {
    return (
      <EntityList apiRoute='api/tietypes' title="Remorque - Types d'attache" editTitle="Type d'attache" displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default TieTypes;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/tieTypes.js
 **/